import React, { ReactNode } from 'react';
import styled from 'styled-components';

import SmallFormMessage, {
  MESSAGE_TYPES,
} from '../../atoms/small-form-message/SmallFormMessage';

import { SmallText } from '../../../styles/generic';
import Spacings from '../../../styles/Spacings';

interface Props {
  hasNegativeMargin?: boolean;
  className?: string;
  children: ReactNode;
}

const ErrorMessage = ({
  hasNegativeMargin = true,
  className,
  children,
}: Props) => (
  <ErrorMessageContainer
    className={className}
    data-testid="error-message-container"
    hasNegativeMargin={hasNegativeMargin}
  >
    {children && (
      <SmallFormMessage type={MESSAGE_TYPES.error}>{children}</SmallFormMessage>
    )}
  </ErrorMessageContainer>
);

const ErrorMessageContainer = styled(SmallText)<{ hasNegativeMargin: boolean }>`
  margin-bottom: ${({ hasNegativeMargin }) =>
    hasNegativeMargin ? `-${Spacings.XS}` : Spacings.S};
  margin-top: ${Spacings.XS};
  min-height: 1.5em;
  word-break: break-word;
`;

export default ErrorMessage;
